import React, { useState } from 'react';
import { observer } from 'mobx-react';
import classes from 'classnames';
import { FormControl, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { QuestionHeading } from './question-heading';

export const PasswordTester = observer(
    ({ ui, handleChange, value, answer }) => {
        const { t } = useTranslation('assessment');
        const [passwordString, setPasswordString] = useState(value);
        const maxLength = 6;

        const onChange = (event) => {
            setPasswordString(event.target.value);
            handleChange(event.target.value);
        };

        return (
            <div className="section-exam">
                <div className={classes('assessment')}>
                    <div className={'assessment-question'}>
                        <QuestionHeading ui={ui} />
                        <FormControl className="password-tester-formcontrol">
                            {!answer ? (
                                <TextField
                                    style={{ background: '#FCFCFC' }}
                                    id="password-tester-password"
                                    helperText={`${
                                        passwordString
                                            ? passwordString.length
                                            : 0
                                    }/${maxLength}`}
                                    variant="outlined"
                                    inputProps={{ maxLength: maxLength }}
                                    value={passwordString}
                                    onChange={onChange}
                                />
                            ) : (
                                <>
                                    <TextField
                                        style={{ background: '#FCFCFC' }}
                                        id="password-tester-password"
                                        variant="outlined"
                                        disabled
                                        inputProps={{ maxLength: maxLength }}
                                        value={
                                            typeof answer.userAnswer.details ===
                                            'string'
                                                ? JSON.parse(
                                                      answer.userAnswer.details
                                                  ).password
                                                : answer.userAnswer.details
                                                      .password
                                        }
                                    />
                                    <div>{/*JSON.stringify(answer)*/}</div>
                                </>
                            )}
                        </FormControl>
                    </div>
                </div>
            </div>
        );
    }
);
